import { Spinner } from '@chakra-ui/react';

export const Loader: React.FunctionComponent = () => (
	<div className='calendar-plus-loader'>
		<Spinner thickness='4px' speed='0.65s' emptyColor='gray.200' color='blue.500' size='xl' mx='auto' />
	</div>
);
